import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {clientsServicesService} from '@store/clients/services/clients-services.service';
import {ClientsServicesState} from '@store/clients/services/clients-services.store';

interface SearchClientsServicesParams extends Partial<ClientsServicesState> {
  contractIds?: number[];
  filterExpiredServices?: boolean;
}

export const searchClientsServicesEffect = createEffectFn((params$: Observable<SearchClientsServicesParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap((params) => clientsServicesService.getClientsServices(params.contractIds || []).pipe(catchError(() => EMPTY))),
  );
});
